/* eslint-disable */
import React, { useState, useLayoutEffect, useRef } from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { makeStyles } from "@material-ui/core/styles";
import { useTranslation } from "react-i18next";
import { formatNumber } from "../../utils/utils";
import useThemeColors from "../../hooks/useThemeColors";
import { usePnlShared } from "../../hooks/usePnlShared";
import { client } from "../../services/axiosClient";
import { Slide as ToastSlide, toast } from "react-toastify";

import {
  blendColors,
  dangerColor,
  grayColor,
  whiteColor,
} from "../../assets/jss/material-dashboard-pro-react";

import { ThreeDots } from "react-loader-spinner";
import Tooltip from "@material-ui/core/Tooltip";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";

import FilterDropdown from "../FilterDropdown/FilterDropdown";
import FilterTag from "../FilterTag/FilterTag";
import { DimDropdown } from "../ResultsFilterBar";
import CustomInput from "../CustomInput/CustomInput";
import ModalHeader from "../ModalHeader";
import PnlTooltip from "./PnlTooltip";
import { Sync } from "@material-ui/icons";
import customDropdownStyle from "assets/jss/material-dashboard-pro-react/components/customDropdownStyle.js";
import modalStyle from "assets/jss/material-dashboard-pro-react/modalStyle.js";
import filterTagStyle from "assets/jss/material-dashboard-pro-react/components/filterTagStyle.js";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClone,
  faFilter,
  faPenToSquare,
  faX,
  faArrowUp,
} from "@fortawesome/free-solid-svg-icons";
import GridContainer from "../Grid/GridContainer";
import GridItem from "../Grid/GridItem";
import Button from "../CustomButtons/Button";

const styles = (theme) => ({
  ...customDropdownStyle(theme),
  ...modalStyle(theme),
  ...filterTagStyle(theme),
  plWrapper: {
    position: "relative",
  },
  plHeader: {
    color: theme.palette.custom.clientTextColor || whiteColor,
    borderRadius: "5px 5px 0 0",
    paddingLeft: "5px",
    textAlign: "left",
    fontSize: "12px",
    paddingTop: "2px",
    paddingBottom: "2px",
    marginBottom: "0",
    marginTop: "0",
    margin: "0",
    backgroundColor: theme.palette.custom.clientColor,
  },
  plName: {
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
    "&.alignRight": {
      textAlign: "right",
      paddingRight: "4px",
    },
    "&:not(.alignRight)": {
      maxWidth: "80%",
    },
  },
  plActionWrapper: {
    fontSize: "14px",
    position: "absolute",
    right: "5px",
    top: "3px",
  },
  plAction: {
    display: "inline",
    margin: "0 5px",
    cursor: "pointer",
  },
  plOuterWrapper: {
    width: "100%",
    padding: "4px 0",
    display: "inline-block",
    fontSize: "12px",
    color: grayColor[6],
    whiteSpace: "nowrap",
    overflow: "hidden",
  },
  plErrorCover: {
    width: "100%",
    height: "calc(100% - 32px)",
    position: "absolute",
    backgroundColor: "white",
    opacity: "0.7",
    "&:hover": {},
  },
  plErrorRefreshIcon: {
    color: theme.palette.custom.clientColor,
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    "& > svg": {
      height: "100px",
      width: "100px",
      cursor: "pointer",
      transition: "all 0.2s",
    },
    "&:hover": {
      "& > svg": {
        transform: "scale(1.2)",
      },
    },
  },
  plErrorMessage: {
    textAlign: "center",
    fontSize: "1.25vmin",
    padding: "0 6px",
    position: "absolute",
    left: "50%",
    bottom: "0",
    transform: "translate(-50%, -100%)",
    borderRadius: "3px",
    color: whiteColor,
    backgroundColor: dangerColor[0],
    opacity: "1",
  },
  plLineWrapper: {
    width: "100%",
    minHeight: "24px",
    display: "flex",
    lineHeight: "2",
    "& > div:first-child": {
      paddingLeft: "4px",
    },
    "& > div:last-child": {
      paddingRight: "4px",
    },
    transition: "opacity 0.2s",
    cursor: "pointer",
  },
  plLineDescription: {
    width: "55%",
    textOverflow: "ellipsis",
    "&.hidden": {
      display: "none",
    },
    "&.nameAndValue": {
      width: "77.5%",
    },
    "&.full": {
      width: "100%",
    },
    "&.threeCol": {
      width: "45%",
    },
  },
  plValue: {
    width: "22.5%",
    textAlign: "right",
    "&.negative": {
      color: dangerColor[0],
    },
    "&.currency.expanded": {
      width: "50%",
    },
    "&.percentual.expanded": {
      width: "50%",
    },
    "&.currency:not(.expanded)": {
      width: "20%",
    },
    "&.percentual:not(.expanded)": {
      width: "25%",
    },
    "&.currency.nameAndValue,&.percentual.nameAndValue": {
      width: "22.5%",
    },
    "&.full": {
      width: "100% !important",
    },
    "&.currency.threeCol": {
      width: "15%",
    },
    "&.valVolume.threeCol": {
      width: "20%",
    },
    "&.percentual.threeCol": {
      width: "20%",
    },
    "&.currency.threeCol.expanded": {
      width: "33.33%",
    },
    "&.valVolume.threeCol.expanded": {
      width: "33.33%",
    },
    "&.percentual.threeCol.expanded": {
      width: "33.34%",
    },
  },
  plNumber: {
    fontFamily: 'Menlo, Monaco, Consolas, "Courier New", monospace;',
  },
  plVolumeValue: {
    width: "45%",
    "&.expanded": {
      width: "100% !important",
    },
    "&.threeCol": {
      width: "60%",
    },
  },
  plSpinner: {
    maxWidth: "20px",
  },
  plPercTotalVolume: {
    fontSize: "10px",
    lineHeight: "12px",
    color: grayColor[0],
    fontStyle: "italic",
  },
  plTableHeader: {
    color: whiteColor,
    backgroundColor: grayColor[6],
  },
  plTotal: {
    backgroundColor: grayColor[8],
    fontWeight: "bold",
    textTransform: "uppercase",
  },
  plSubTotal: {
    backgroundColor: grayColor[13],
    "& > div:first-child": {
      paddingLeft: "12px !important",
    },
  },
  plLevel3: {
    color: grayColor[1],
  },
  plLevel4: {
    color: grayColor[1],
  },
  highlighted: {
    backgroundColor:
      blendColors(grayColor[8], theme.palette.custom.clientColor, 0.9) +
      " !important",
  },
  plLoadingDetails: {
    backgroundSize: "200% 100%",
    backgroundImage:
      "linear-gradient(to right, " +
      blendColors(grayColor[8], theme.palette.custom.clientColor, 0.9) +
      " 50%, " +
      blendColors(grayColor[8], theme.palette.custom.clientColor, 0.8) +
      " 50%)",
    "-webkit-transition": "background-position 3s ease-in-out",
    "-moz-transition": "background-position 3s ease-in-out",
    transition: "background-position 3s ease-in-out",
    "&:hover": {
      backgroundPosition: "-100% 0",
    },
  },
  plDrillDown: {
    "& > span:before": {
      fontFamily: "'Font Awesome 5 Free'",
      padding: "0 4px 0 0",
      fontWeight: "900",
      fontSize: "10px",
      cursor: "pointer",
    },
  },
  plDrillDownOpen: {
    "& > span:before": {
      content: "'\\f146'",
    },
  },
  plDrillDownClosed: {
    "& > span:before": {
      content: "'\\f0fe'",
    },
  },
  plIndentL2: {
    paddingLeft: "14px !important",
    "& > span:before": {
      color: grayColor[4],
      content: "'\\2517'",
      padding: "0 3px 0 0",
      fontSize: "10px",
    },
  },
  plIndentL3: {
    paddingLeft: "30px !important",
    "& > span:before": {
      color: grayColor[4],
      content: "'\\2517'",
      padding: "0 3px 0 0",
      fontSize: "10px",
    },
  },
  plDrillDownIndentL2: {
    paddingLeft: "14px !important",
    "&::before": {
      color: grayColor[4],
      content: "'\\2517'",
      fontSize: "10px",
      marginRight: "3px",
    },
  },
  plDrillDownIndentL3: {
    paddingLeft: "28px !important",
    "&::before": {
      color: grayColor[4],
      content: "'\\2517'",
      fontSize: "10px",
      marginRight: "3px",
    },
  },
  plComparison: {
    "&:before": {
      content: "'\\25cf'",
      marginRight: "4px",
      fontSize: "18px",
      lineHeight: "12px",
    },
    "&.n1:before": {
      color: "#F44336",
    },
    "&.n2:before": {
      color: "#F76C24",
    },
    "&.n3:before": {
      color: "#FB9612",
    },
    "&.n4:before": {
      color: "#FFC000",
    },
    "&.n5:before": {
      color: "#F6C737",
    },
    "&.n6:before": {
      color: "#EECE6E",
    },
    "&.n7:before": {
      color: "#E5D5A5",
    },
    "&.n8:before": {
      color: "#DDDDDD",
    },
    "&.n9:before": {
      color: "#C8D6C8",
    },
    "&.n10:before": {
      color: "#B3CFB4",
    },
    "&.n11:before": {
      color: "#9EC9A0",
    },
    "&.n12:before": {
      color: "#8AC28C",
    },
    "&.n13:before": {
      color: "#75BC78",
    },
    "&.n14:before": {
      color: "#60B564",
    },
    "&.n15:before": {
      color: "#4CAF50",
    },
  },
  plDeltaArrow: {
    marginRight: "4px",
    fontSize: "12px",
    display: "inline-block",
    width: "18px",
    textAlign: "center",
    "&.n1": {
      color: "#F44336",
    },
    "&.n2": {
      color: "#F76C24",
    },
    "&.n3": {
      color: "#FB9612",
    },
    "&.n4": {
      color: "#FFC000",
    },
    "&.n5": {
      color: "#F6C737",
    },
    "&.n6": {
      color: "#EECE6E",
    },
    "&.n7": {
      color: "#E5D5A5",
    },
    "&.n8": {
      color: "#DDDDDD",
    },
    "&.n9": {
      color: "#C8D6C8",
    },
    "&.n10": {
      color: "#B3CFB4",
    },
    "&.n11": {
      color: "#9EC9A0",
    },
    "&.n12": {
      color: "#8AC28C",
    },
    "&.n13": {
      color: "#75BC78",
    },
    "&.n14": {
      color: "#60B564",
    },
    "&.n15": {
      color: "#4CAF50",
    },
  },
  faded: {
    opacity: "0.3",
  },
  hidden: {
    display: "none",
  },
  pin: {
    position: "absolute",
    right: "0",
    color: grayColor[9],
    "&.pinned": {
      color: grayColor[1],
    },
    "&:before": {
      fontFamily: "'Font Awesome 5 Free'",
      padding: "0 4px 0 0",
      fontWeight: "900",
      fontSize: "10px",
      content: "'\\f08d' !important",
    },
  },
  contextMenu: {
    "& .MuiMenu-paper": {
      borderRadius: "3px",
      border: "0",
      boxShadow: "0 2px 5px 0 rgba(0, 0, 0, 0.26)",
      top: "100%",
      zIndex: "1000",
      minWidth: "160px",
      padding: "0",
      margin: "2px 0 0",
      fontSize: "14px",
      textAlign: "left",
      listStyle: "none",
      backgroundColor: whiteColor,
      backgroundClip: "padding-box",
    },
    "& .MuiList-padding": {
      paddingTop: "1px !important",
      paddingBottom: "1px !important",
    },
  },
  contextMenuItem: {
    fontSize: "13px",
    padding: "8px 10px",
    margin: "0 2px",
    borderRadius: "2px",
    position: "relative",
    transition: "all 150ms linear",
    display: "block",
    clear: "both",
    fontWeight: "400",
    height: "100%",
    color: grayColor[7],
    whiteSpace: "nowrap",
    minHeight: "unset",
    "&:hover,&.MuiListItem-root.Mui-focusVisible:hover": {
      backgroundColor: theme.palette.custom.clientColor,
      color: theme.palette.custom.clientTextColor || whiteColor,
      boxShadow:
        "0 4px 20px 0 rgba(0, 0, 0, 0.14), 0 7px 10px -5px rgba(" +
        theme.palette.custom.clientColor +
        ", 0.4)",
    },
    "&.MuiListItem-root.Mui-focusVisible": {
      backgroundColor: "#fff",
    },
  },
  // Performance-optimized JSS classes for previously inline styles
  loadingContainer: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  spinnerContainer: {
    height: "100%",
  },
  opportunityDialogContainer: {
    marginTop: "8px",
  },
  scopePlaceholder: {
    color: "gray",
    fontStyle: "italic",
  },
  filterContainer: {
    marginLeft: "6px",
  },
  noFiltersMessage: {
    color: "gray",
    fontStyle: "italic",
    fontSize: "12px",
  },
  opportunityInputContainer: {
    marginTop: "15px",
  },
  opportunityInputFormControl: {
    paddingTop: "0",
    margin: "0",
  },
  opportunityNote: {
    color: "gray",
    fontStyle: "italic",
    fontSize: "12px",
    marginTop: "10px",
    marginBottom: "0",
  },
});

const Pnl = (props) => {
  const { clientColor } = useThemeColors();
  const useStyles = makeStyles(styles);
  const classes = useStyles();

  // Get shared functions from context
  const {
    getCriticalityLevel,
    formatValue,
    getPlPercentValue,
    oomData,
    showValueByVolumeDecimalsData,
    benchmark,
  } = usePnlShared();

  // const formatter = new Intl.NumberFormat("us-EN", {
  //   style: "decimal",
  //   useGrouping: true,
  // });
  const { t, i18n } = useTranslation();

  const [showValueByVolumeDecimals, setShowValueByVolumeDecimals] =
    useState(false);

  const [filterDropdownOpen, setFilterDropdownOpen] = useState(false);
  const [filterTooltipOpen, setFilterTooltipOpen] = useState(false);

  // Context menu state
  const [contextMenu, setContextMenu] = useState({
    mouseX: null,
    mouseY: null,
    metaName: null,
    numPL: null,
    valueType: null, // 'value' or 'percentage'
  });

  // Opportunity dialog state
  const [opportunityDialogOpen, setOpportunityDialogOpen] = useState(false);
  const [selectedOpportunity, setSelectedOpportunity] = useState(null);
  const [opportunityDescription, setOpportunityDescription] = useState("");
  const [opportunitySubmitting, setOpportunitySubmitting] = useState(false);
  const opportunityInputRef = useRef(null);

  // Value tooltip state (TreeMap style)
  const [valueTooltip, setValueTooltip] = useState({
    visible: false,
    x: 0,
    y: 0,
    metaName: null,
    numPL: null,
  });
  const [mouseMoving, setMouseMoving] = useState(false);
  const mouseMovingTimer = useRef(null);
  const tooltipRef = useRef(null);
  const tooltipDelayTimer = useRef(null);

  // Notification function
  const notify = (text, type = "info", time = 3000) =>
    toast(t(text), {
      position: "top-right",
      autoClose: time,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: false,
      progress: undefined,
      theme: "light",
      type: type,
      transition: ToastSlide,
    });

  const {
    plStructure,
    revenueAnchors,
    marginAnchors,
    netRevenueAnchor,
    combinedAboveAnchor,
    revenueReference,
    serveMarginAnchor,
    numPL,
    numPLs,
    maxPLs,
    plNames,
    plName,
    filterable,
    handleChangePLNameClick,
    handleMouseLeavePLLine,
    handleMouseOverPLLine,
    mouseOverPLLine,
    mouseOverPLLineFade,
    drillDownsOpen,
    setDrillDownsOpen,
    timersAllowed,
    filtersListTranslated,
    filtersActiveList,
    filtersSequence,
    filterScopeData,
    filterMenuClickHandler,
    filterDropdownProps,
    addPL,
    removePL,
    plsOnError,
    retryPL,
    plsToRefresh,
    isRefreshing,
    plValues,
    volumeUnit,
    volumeL12M,
    currencyUnit,
    showValueType,
    isLoading,
    nameOnly,
    showColumns,
    nameAlignRight,
    showPin,
    pinnedName,
    setPinnedName,
    onContextMenuStateChange,
    handleOpenAnalysisDrawer,
    showAnalysisOption,
    plLineDeltas,
    fixedHighlightLine,
    onOpenAIChat,
    showValueTooltip,
    hideVolume,
    namingPlaceholder,
  } = props;

  const getLineType = (meta_name) => {
    if (revenueAnchors && revenueAnchors.includes(meta_name)) {
      return "revenue_anchor";
    }
    if (marginAnchors && marginAnchors.includes(meta_name)) {
      return "margin_anchor";
    }
    return "cost";
  };

  // Arrow rotation reflects movement direction; color reflects impact based on line type
  const getDeltaRotation = (delta, meta_name) => {
    const clampedDelta = Math.max(-5, Math.min(5, delta));
    return 90 - clampedDelta * 18; // -5pp→180°, 0pp→90°, +5pp→0°
  };

  const getDeltaCriticalityLevel = (delta, meta_name) => {
    const lineType = getLineType(meta_name);
    // For cost lines, invert delta logic (increase = bad, decrease = good)
    const effectiveDelta = lineType === "cost" ? -delta : delta;

    if (effectiveDelta <= -4) return 1;
    if (effectiveDelta <= -3) return 2;
    if (effectiveDelta <= -2.5) return 3;
    if (effectiveDelta <= -2) return 4;
    if (effectiveDelta <= -1.5) return 5;
    if (effectiveDelta <= -1) return 6;
    if (effectiveDelta < -0.5) return 7;
    if (effectiveDelta >= 4) return 15;
    if (effectiveDelta >= 3) return 14;
    if (effectiveDelta >= 2.5) return 13;
    if (effectiveDelta >= 2) return 12;
    if (effectiveDelta >= 1.5) return 11;
    if (effectiveDelta >= 1) return 10;
    if (effectiveDelta > 0.5) return 9;
    return 8;
  };

  const shouldShowDeltaArrow = (meta_name) => {
    const lineType = getLineType(meta_name);
    if (lineType === "revenue_anchor") {
      return false;
    }
    return (
      plLineDeltas &&
      plLineDeltas[meta_name] !== undefined &&
      plLineDeltas[meta_name] !== null
    );
  };

  const shouldShowDeltaArrowForPL = () => {
    return plLineDeltas && Object.keys(plLineDeltas).length > 0;
  };

  // Simplified spinner component
  const plSpinner = (
    <GridContainer
      justifyContent={"flex-end"}
      alignItems={"center"}
      className={classes.spinnerContainer}
    >
      <GridItem>
        <ThreeDots
          color={grayColor[0]}
          ariaLabel="loading"
          width={"20px"}
          height={"12px"}
          wrapperStyle={{}}
          wrapperClass={classes.plSpinner}
        />
      </GridItem>
    </GridContainer>
  );

  // Build a lookup map from meta_name -> line for efficient parent traversal
  const parentLookup = useRef({});
  useLayoutEffect(() => {
    if (plStructure.current) {
      const lookup = {};
      plStructure.current.forEach((line) => {
        lookup[line.meta_name] = line;
      });
      parentLookup.current = lookup;
    }
  }, [plStructure.current]);

  // Check if any ancestor in the chain is collapsed (not in drillDownsOpen)
  const isHiddenByAncestor = (line) => {
    if (!line.parent) return false;
    if (!drillDownsOpen.includes(line.parent)) return true;
    const parentLine = parentLookup.current[line.parent];
    return parentLine ? isHiddenByAncestor(parentLine) : false;
  };

  // Simplified event handlers
  const handleDrillDownClick = (meta_name) => {
    if (drillDownsOpen.includes(meta_name)) {
      setDrillDownsOpen(drillDownsOpen.filter((item) => item !== meta_name));
    } else {
      setDrillDownsOpen((drillDownsOpen) => [...drillDownsOpen, meta_name]);
    }
    return false;
  };

  const handlePinClick = (meta_name) => {
    if (pinnedName === meta_name || isRefreshing) {
      setPinnedName(null);
    } else {
      setPinnedName(meta_name);
    }
  };

  // Simplified context menu handlers
  const handleContextMenu = (event, metaName, numPL, valueType) => {
    event.preventDefault();
    setContextMenu({
      mouseX: event.clientX + 2,
      mouseY: event.clientY - 6,
      metaName,
      numPL,
      valueType,
    });
    if (onContextMenuStateChange) {
      onContextMenuStateChange(true, metaName);
    }
  };

  const handleCloseContextMenu = () => {
    setContextMenu({
      mouseX: null,
      mouseY: null,
      metaName: null,
      numPL: null,
      valueType: null,
    });
    if (onContextMenuStateChange) {
      onContextMenuStateChange(false, null);
    }
  };

  const handleMarkAsOpportunity = () => {
    setSelectedOpportunity({
      metaName: contextMenu.metaName,
      numPL: contextMenu.numPL,
      valueType: contextMenu.valueType,
      value: plValues[contextMenu.numPL]?.[contextMenu.metaName],
      lineName: plStructure.current.find(
        (line) => line.meta_name === contextMenu.metaName,
      )?.name,
    });
    setOpportunityDialogOpen(true);
    handleCloseContextMenu();
  };

  const handleOpenAnalysis = () => {
    if (handleOpenAnalysisDrawer) {
      handleOpenAnalysisDrawer(contextMenu.metaName, contextMenu.numPL);
    }
    handleCloseContextMenu();
  };

  const handleCloseOpportunityDialog = () => {
    if (opportunitySubmitting) return; // Prevent closing while submitting
    setOpportunityDialogOpen(false);
    setTimeout(() => {
      setSelectedOpportunity(null);
      setOpportunityDescription("");
      setOpportunitySubmitting(false);
    }, 150);
  };

  const handleConfirmOpportunity = () => {
    if (!selectedOpportunity || !opportunityDescription.trim()) {
      notify(t("pnl.opportunity_description_required"), "error");
      return;
    }

    setOpportunitySubmitting(true);

    // Build scope structure similar to Initiatives view
    const scope = {
      filters: {},
      filters_sequence: [],
    };

    if (filterScopeData && filterScopeData[selectedOpportunity.numPL]) {
      const scopeData = filterScopeData[selectedOpportunity.numPL];
      scopeData.forEach((filter) => {
        if (filter.filterName !== "period") {
          scope.filters[filter.filterName] = filter.items || [];
          scope.filters_sequence.push(filter.filterName);
        }
      });
    }

    const payload = {
      description: opportunityDescription.trim(),
      scope: [scope], // Wrap in array as per Initiatives structure
      pnl_impact_line: selectedOpportunity.metaName,
    };

    client
      .post("api/initiatives_add_opportunity/", payload)
      .then((response) => {
        if (response.data.success) {
          notify(t("pnl.opportunity_saved_success"), "success");
          handleCloseOpportunityDialog();
        } else {
          notify(t("pnl.opportunity_save_error"), "error");
        }
      })
      .catch((error) => {
        console.error("Save Opportunity Error:", error);
        notify(t("pnl.opportunity_save_error"), "error");
      })
      .finally(() => {
        setOpportunitySubmitting(false);
      });
  };

  // Auto-focus on the input when dialog opens
  useLayoutEffect(() => {
    if (opportunityDialogOpen) {
      setTimeout(() => {
        if (opportunityInputRef.current) {
          const inputElement =
            opportunityInputRef.current.querySelector("input");
          if (inputElement) {
            inputElement.focus();
          } else {
            opportunityInputRef.current.focus();
          }
        }
      }, 300);
    }
  }, [opportunityDialogOpen]);

  // Simplified scope information function
  const getScopeInformation = () => {
    if (!selectedOpportunity) return null;

    const scopeInfo = {
      allFilters: [],
      viewType: "unknown",
    };

    if (filterScopeData && filterScopeData[selectedOpportunity.numPL]) {
      scopeInfo.viewType = filterScopeData.viewType || "standardized";
      scopeInfo.allFilters = filterScopeData[selectedOpportunity.numPL]
        .filter((filter) => filter.filterName !== "period")
        .map((filter) => ({
          name: filter.name,
          type: filter.type,
          filterName: filter.filterName,
          items: filter.items || [],
        }));
    }

    return scopeInfo;
  };

  // Simple className calculations - no need for useMemo
  const headerClassName = cx({
    [classes.plHeader]: true,
    ["first"]: numPL === 1,
  });

  const nameClassName = cx({
    [classes.plName]: true,
    ["alignRight"]: nameAlignRight,
  });

  // Simple handler functions - no need for useCallback
  const handleChangePLNameClickHandler = () =>
    handleChangePLNameClick ? handleChangePLNameClick(numPL) : null;
  const addPLHandler = () => addPL(numPL);
  const removePLHandler = () => removePL(numPL);
  const retryPLHandler = () => retryPL(numPL);

  // Simple boolean checks - no need for useMemo
  const showNameColumn = showColumns.includes("name");
  const showValueColumn = showColumns.includes("val");
  const showValVolumeColumn = showColumns.includes("val_volume");
  const showPercentageColumn = showColumns.includes("percentage");
  const showDeltaColumn = showColumns.includes("delta");
  const isThreeColumnView =
    showValueColumn && showValVolumeColumn && showPercentageColumn;
  const isRefreshingOrToRefresh = isRefreshing || plsToRefresh.includes(numPL);

  // Calculate delta values between PL1 and PL2 (in percentage points)
  const calculateDeltaValue = (meta_name) => {
    if (!plValues[1] || !plValues[2]) return null;

    let activeAnchor;
    if (revenueReference === "combined") {
      const lineIdx = plStructure.current.findIndex(
        (l) => l.meta_name === meta_name,
      );
      const netIdx = plStructure.current.findIndex(
        (l) => l.meta_name === netRevenueAnchor.current,
      );
      activeAnchor =
        lineIdx < netIdx
          ? combinedAboveAnchor?.current
          : netRevenueAnchor.current;
    } else {
      activeAnchor = revenueReference || netRevenueAnchor.current;
    }
    const revenue1 = plValues[1]?.[activeAnchor];
    const revenue2 = plValues[2]?.[activeAnchor];

    if (!revenue1 || !revenue2) return null;

    const value1 = plValues[1]?.[meta_name];
    const value2 = plValues[2]?.[meta_name];

    if (
      value1 === undefined ||
      value1 === null ||
      value2 === undefined ||
      value2 === null
    ) {
      return null;
    }

    const percent1 = (100 * value1) / revenue1;
    const percent2 = (100 * value2) / revenue2;

    return percent2 - percent1;
  };

  // Calculate volume delta (as percentage change)
  const calculateVolumeDelta = () => {
    if (!plValues[1]?.volume || !plValues[2]?.volume) return null;

    const vol1 = plValues[1].volume;
    const vol2 = plValues[2].volume;

    return ((vol2 - vol1) / vol1) * 100;
  };

  // Calculate opacity for delta fade effect
  const calculateDeltaOpacity = (delta, metaName) => {
    if (!showDeltaColumn || delta === null) return 1;

    // Remove fade effect when line is highlighted (mouseOver)
    if (mouseOverPLLine && mouseOverPLLine === metaName && timersAllowed) {
      return 1;
    }

    // Find max absolute delta across all lines (excluding level 1 totals)
    let maxAbsDelta = 0;
    if (plStructure.current) {
      plStructure.current.forEach((line) => {
        // Skip level 1 (totals) from scale calculation
        if (line.level === 1) return;

        const lineDelta = calculateDeltaValue(line.meta_name);
        if (lineDelta !== null) {
          maxAbsDelta = Math.max(maxAbsDelta, Math.abs(lineDelta));
        }
      });
    }

    // Use min between maxAbsDelta and 5pp as the scale
    const scale = Math.min(maxAbsDelta, 5);

    // Calculate opacity: 0pp -> 20% opacity, scale -> 100% opacity
    const absDelta = Math.abs(delta);
    const opacity = 0.2 + 0.8 * (absDelta / scale);

    return Math.min(opacity, 1); // Cap at 1 (100%)
  };

  // Simplified conditional checks
  const isExpandedView = (numPL > 1 && numPLs >= 4) || !showNameColumn;
  const isNameAndValueView =
    showNameColumn && showColumns.length === 2 && !isThreeColumnView;
  const isFullView = showColumns.length === 1;
  const isHiddenView = numPL > 1 && numPLs >= 4;
  const isNameOnlyView = showNameColumn && showColumns.length === 1;
  const isCurrencyNameAndValue =
    !showPercentageColumn && showColumns.length === 2 && !isThreeColumnView;
  const isPercentualNameAndValue =
    !showValueColumn && showColumns.length === 2 && !isThreeColumnView;
  const isExpandedWithoutName =
    !showNameColumn && showColumns.length === 2 && !isThreeColumnView;
  const hasVolumeData = plValues[numPL]?.volume && volumeL12M.current;
  const canShowComparison =
    !isRefreshingOrToRefresh && !plsToRefresh.includes(numPL);
  const shouldShowAnalysisOption =
    showAnalysisOption &&
    handleOpenAnalysisDrawer &&
    contextMenu.metaName &&
    !revenueAnchors.includes(contextMenu.metaName);

  const volumeLineDescriptionClassName = cx({
    [classes.plLineDescription]: true,
    ["hidden"]: isHiddenView,
    ["nameAndValue"]: isNameAndValueView,
    ["full"]: isFullView,
    ["nameOnly"]: isNameOnlyView,
    ["threeCol"]: isThreeColumnView,
  });

  const volumeValueClassName = cx({
    [classes.plValue]: true,
    [classes.plNumber]: true,
    [classes.plVolumeValue]: true,
    ["expanded"]: isExpandedView,
    ["nameAndValue"]: isNameAndValueView,
    ["threeCol"]: isThreeColumnView,
  });

  const tableHeaderDescriptionClassName = cx({
    [classes.plLineDescription]: true,
    [classes.plTableHeader]: true,
    ["hidden"]: isHiddenView,
    ["nameAndValue"]: isNameAndValueView,
    ["full"]: isFullView,
    ["threeCol"]: isThreeColumnView,
  });

  const tableHeaderValueClassName = cx({
    [classes.plValue]: true,
    [classes.plTableHeader]: true,
    ["currency"]: true,
    ["expanded"]: isExpandedView || isExpandedWithoutName,
    ["nameAndValue"]: isCurrencyNameAndValue,
    ["full"]: isFullView,
    ["threeCol"]: isThreeColumnView,
  });

  const tableHeaderValVolumeClassName = cx({
    [classes.plValue]: true,
    [classes.plTableHeader]: true,
    ["valVolume"]: true,
    ["expanded"]: isExpandedView || isExpandedWithoutName,
    ["threeCol"]: isThreeColumnView,
  });

  const tableHeaderPercentageClassName = cx({
    [classes.plValue]: true,
    [classes.plTableHeader]: true,
    ["percentual"]: true,
    ["expanded"]: isExpandedView || isExpandedWithoutName,
    ["nameAndValue"]: isPercentualNameAndValue,
    ["full"]: isFullView,
    ["threeCol"]: isThreeColumnView,
  });

  const tableHeaderDeltaClassName = cx({
    [classes.plValue]: true,
    [classes.plTableHeader]: true,
    ["percentual"]: true,
    ["expanded"]: isExpandedView || isExpandedWithoutName,
    ["nameAndValue"]: isPercentualNameAndValue,
    ["full"]: isFullView,
  });

  const isNegativeValue = (meta_name) =>
    plValues[numPL]?.[meta_name] && plValues[numPL]?.[meta_name] < 0;

  const shouldShowComparison = (val) => {
    // Don't show comparison dots if this PL will show delta arrows
    if (shouldShowDeltaArrowForPL()) {
      return false;
    }
    // Don't show comparison dots if benchmark is null
    if (!benchmark) {
      return false;
    }
    return (
      canShowComparison &&
      val.ref_values != null &&
      plValues[numPL]?.[val.meta_name] &&
      !revenueAnchors.includes(val.meta_name)
    );
  };

  // Handle value cell mouse enter (TreeMap style)
  const handleValueCellMouseEnter = (e, meta_name, numPL) => {
    if (isRefreshingOrToRefresh || !plValues[numPL]?.[meta_name]) return;

    // Capture coordinates before async timer (React recycles synthetic events)
    // Use data attribute: JSS class names in production are hashed (e.g. jss1) and do not contain "plWrapper"
    const plWrapperRect = e.currentTarget
      .closest("[data-pnl-root]")
      ?.getBoundingClientRect();
    if (!plWrapperRect) return;

    const clientX = e.clientX;
    const clientY = e.clientY;

    // Delay showing tooltip by 500ms
    clearTimeout(tooltipDelayTimer.current);
    tooltipDelayTimer.current = setTimeout(() => {
      // Default position: close to cursor (right and below)
      let initialX = clientX - plWrapperRect.left + 10;
      let initialY = clientY - plWrapperRect.top + 20;

      // Estimate tooltip size (minWidth: 200px from CSS) and check viewport boundaries
      const estimatedTooltipWidth = 220;
      const estimatedTooltipHeight = 80;

      let offsetX = 0;
      let offsetY = 0;

      // Check if tooltip would go beyond viewport right edge
      if (clientX + 10 + estimatedTooltipWidth >= window.innerWidth - 10) {
        offsetX = -estimatedTooltipWidth - 20;
      }

      // Check if tooltip would go beyond viewport bottom edge
      if (clientY + 20 + estimatedTooltipHeight >= window.innerHeight - 10) {
        offsetY = -estimatedTooltipHeight - 40;
      }

      setValueTooltip({
        visible: true,
        x: initialX + offsetX,
        y: initialY + offsetY,
        metaName: meta_name,
        numPL: numPL,
      });
    }, 500);
  };

  // Handle value cell mouse move (TreeMap style)
  const handleValueCellMouseMove = (e) => {
    if (!showValueTooltip || !valueTooltip.visible || !tooltipRef.current)
      return;

    const plWrapperRect = e.currentTarget
      .closest("[data-pnl-root]")
      ?.getBoundingClientRect();
    if (!plWrapperRect) return;

    const tooltipRect = tooltipRef.current.getBoundingClientRect();

    // Default position: close to cursor (right and below)
    let x = e.clientX - plWrapperRect.left + 10;
    let y = e.clientY - plWrapperRect.top + 20;

    let offsetX = 0;
    let offsetY = 0;

    // Calculate absolute position of tooltip in viewport
    const tooltipRight = e.clientX + 10 + tooltipRect.width;
    const tooltipBottom = e.clientY + 20 + tooltipRect.height;

    // Adjust if tooltip would go beyond viewport right edge
    if (tooltipRight >= window.innerWidth - 10) {
      offsetX = -tooltipRect.width - 20;
    }

    // Adjust if tooltip would go beyond viewport bottom edge
    if (tooltipBottom >= window.innerHeight - 10) {
      offsetY = -tooltipRect.height - 40;
    }

    setValueTooltip((prev) => ({
      ...prev,
      x: x + offsetX,
      y: y + offsetY,
    }));

    // Hide tooltip during rapid movement
    setMouseMoving(true);
    clearTimeout(mouseMovingTimer.current);
    mouseMovingTimer.current = setTimeout(() => {
      setMouseMoving(false);
    }, 300);
  };

  // Handle value cell mouse leave
  const handleValueCellMouseLeave = () => {
    clearTimeout(tooltipDelayTimer.current);
    setValueTooltip({
      visible: false,
      x: 0,
      y: 0,
      metaName: null,
      numPL: null,
    });
    setMouseMoving(false);
  };

  // Simplified state update
  useLayoutEffect(() => {
    if (showValueByVolumeDecimalsData !== showValueByVolumeDecimals) {
      setShowValueByVolumeDecimals(showValueByVolumeDecimalsData);
    }
  }, [showValueByVolumeDecimalsData, showValueByVolumeDecimals]);

  if (isLoading) {
    return (
      <div className={classes.loadingContainer}>
        <ThreeDots width={"120px"} color={clientColor} ariaLabel="loading" />
      </div>
    );
  }

  return (
    <div
      data-pnl-root
      className={cx({
        [classes.plWrapper]: true,
      })}
    >
      {/* region P&L Header */}
      {(plNames || plName || nameOnly) && (
        <div className={headerClassName}>
          <div
            className={nameClassName}
            onClick={handleChangePLNameClickHandler}
          >
            {namingPlaceholder ? (
              <span style={{ fontStyle: "italic", opacity: 0.5 }}>
                {t("pnl.naming_placeholder")}
              </span>
            ) : plNames
              ? plNames[numPL] && plNames[numPL] !== ""
                ? plNames[numPL]
                : "P&L " + numPL.toString()
              : plName}
          </div>
          {!nameOnly && (
            <div className={classes.plActionWrapper}>
              {onOpenAIChat && (
                <Tooltip title={t("ai_chat.button_text")}>
                  <div
                    className={classes.plAction}
                    onClick={() => onOpenAIChat(numPL)}
                  >
                    <span style={{ fontSize: "16px" }}>✦</span>
                  </div>
                </Tooltip>
              )}
              {plNames && numPLs <= 4 && (
                <Tooltip title={t("pnl.add_edit_name")}>
                  <div
                    className={classes.plAction}
                    onClick={handleChangePLNameClickHandler}
                  >
                    <FontAwesomeIcon icon={faPenToSquare} />
                  </div>
                </Tooltip>
              )}
              {filterable && (
                <Tooltip
                  title={t("pnl.filter_tooltip")}
                  open={filterTooltipOpen}
                  onOpen={() => { if (!filterDropdownOpen) setFilterTooltipOpen(true); }}
                  onClose={() => setFilterTooltipOpen(false)}
                  disableFocusListener
                  disableTouchListener
                >
                  <div className={classes.plAction}>
                  {filterDropdownProps ? (
                    <DimDropdown
                      filtersList={filterDropdownProps.filtersList}
                      filtersNames={filterDropdownProps.filtersNames}
                      commonFilters={filterDropdownProps.plFilters}
                      commonFiltersSequence={filterDropdownProps.plFiltersSequence}
                      sections={filterDropdownProps.sections || []}
                      language={filterDropdownProps.language}
                      color={filterDropdownProps.color || "#888"}
                      includePeriodInSequence
                      onSelect={(f) => {
                        if (f === "period" && filterDropdownProps.onPeriodSelect) {
                          filterDropdownProps.onPeriodSelect();
                        } else {
                          filterMenuClickHandler("pl", numPL)(f);
                        }
                      }}
                      onOpenChange={(isOpen) => {
                        setFilterDropdownOpen(isOpen);
                        if (isOpen) setFilterTooltipOpen(false);
                      }}
                      customTrigger={
                        <span title={t("pnl.filter_tooltip")}>
                          <FontAwesomeIcon icon={faFilter} />
                        </span>
                      }
                    />
                  ) : (
                    <FilterDropdown
                      button={<FontAwesomeIcon icon={faFilter} />}
                      dropPlacement={"bottom-start"}
                      hoverColor={"client"}
                      dropdownHeader={t("pnl.add_change_filter")}
                      dropdownList={filtersListTranslated()}
                      dropdownActiveItems={filtersActiveList("pl", numPL)}
                      dropdownFilterSequence={filtersSequence(numPL)}
                      tooltip={t("pnl.add_change_filter")}
                      onClick={filterMenuClickHandler("pl", numPL)}
                    />
                  )}
                  </div>
                </Tooltip>
              )}
              {addPL && numPLs < maxPLs && (
                <Tooltip title={t("pnl.clone_pnl")}>
                  <div className={classes.plAction} onClick={addPLHandler}>
                    <FontAwesomeIcon icon={faClone} />
                  </div>
                </Tooltip>
              )}
              {removePL && (
                <Tooltip title={t("pnl.remove")}>
                  <div className={classes.plAction} onClick={removePLHandler}>
                    <FontAwesomeIcon icon={faX} />
                  </div>
                </Tooltip>
              )}
            </div>
          )}
        </div>
      )}
      {/* endregion */}
      {/* region P&L Lines */}
      <div className={classes.plOuterWrapper}>
        {/* region P&L Error */}
        {plsOnError.includes(numPL) && (
          <div className={classes.plErrorCover}>
            <div
              className={classes.plErrorRefreshIcon}
              onClick={retryPLHandler}
            >
              <Sync />
            </div>
            <div className={classes.plErrorMessage}>
              {t("pnl.error_on_load")}
            </div>
          </div>
        )}
        {/* endregion */}
        {/* region P&L Volume */}
        {!hideVolume && (
          <>
            <div
              className={classes.plLineWrapper}
              style={{ marginBottom: !volumeL12M.current ? "4px" : "0" }}
            >
              {showNameColumn && (
                <div className={volumeLineDescriptionClassName}>
                  {t("pnl.volume")}
                </div>
              )}
              {(showValueColumn || showPercentageColumn) && (
                <div className={volumeValueClassName}>
                  {!isRefreshingOrToRefresh &&
                    (plValues[numPL]?.volume ? (
                      <>
                        {formatNumber(plValues[numPL].volume)}
                        <span className={classes.plUnit}>
                          {" " + volumeUnit.current}
                        </span>
                      </>
                    ) : (
                      "-"
                    ))}
                  {isRefreshingOrToRefresh && plSpinner}
                </div>
              )}
              {showDeltaColumn && (
                <div className={volumeValueClassName}>
                  {!isRefreshingOrToRefresh &&
                    (() => {
                      const volumeDelta = calculateVolumeDelta();
                      if (volumeDelta === null) return "-";
                      const sign = volumeDelta >= 0 ? "+" : "";
                      return `${sign}${volumeDelta.toFixed(1)}%`;
                    })()}
                  {isRefreshingOrToRefresh && plSpinner}
                </div>
              )}
            </div>
            {volumeL12M.current && (
              <div className={classes.plLineWrapper}>
                {showNameColumn && (
                  <div
                    className={cx({
                      [classes.plLineDescription]: true,
                      [classes.plPercTotalVolume]: true,
                      ["hidden"]: isHiddenView,
                      ["nameAndValue"]: isNameAndValueView,
                      ["nameOnly"]: isNameOnlyView,
                      ["threeCol"]: isThreeColumnView,
                    })}
                  >
                    {t("pnl.percent_of_total_volume")}
                  </div>
                )}
                {(showValueColumn || showPercentageColumn) && (
                  <div
                    className={cx({
                      [classes.plValue]: true,
                      [classes.plNumber]: true,
                      [classes.plPercTotalVolume]: true,
                      [classes.plVolumeValue]: true,
                      ["expanded"]: isExpandedView,
                      ["nameAndValue"]: isNameAndValueView,
                      ["threeCol"]: isThreeColumnView,
                    })}
                  >
                    {!isRefreshingOrToRefresh &&
                      (hasVolumeData
                        ? (
                            (100 * plValues[numPL].volume) /
                            volumeL12M.current
                          ).toFixed(1) + "%"
                        : "-")}
                    {isRefreshingOrToRefresh && plSpinner}
                  </div>
                )}
              </div>
            )}
          </>
        )}
        {/* endregion */}
        {/* region P&L Table Header */}
        <div className={classes.plLineWrapper}>
          {showNameColumn && (
            <div className={tableHeaderDescriptionClassName}>{"P&L"}</div>
          )}
          {showValueColumn && (
            <div className={tableHeaderValueClassName}>
              {currencyUnit && !isRefreshingOrToRefresh
                ? isThreeColumnView
                  ? currencyUnit + oomData.x
                  : showValueType === "value"
                    ? currencyUnit + oomData.x
                    : currencyUnit + "/" + volumeUnit.current
                : "-"}
            </div>
          )}
          {showValVolumeColumn && (
            <div className={tableHeaderValVolumeClassName}>
              {currencyUnit && !isRefreshingOrToRefresh
                ? currencyUnit + "/" + volumeUnit.current
                : "-"}
            </div>
          )}
          {showPercentageColumn && (
            <div className={tableHeaderPercentageClassName}>{"%"}</div>
          )}
          {showDeltaColumn && (
            <div className={tableHeaderDeltaClassName}>
              Δ <span style={{ textTransform: "none" }}>pp</span>
            </div>
          )}
        </div>
        {/* endregion */}
        {/* region P&L Financials */}
        <div
          onMouseLeave={handleMouseLeavePLLine ? handleMouseLeavePLLine : null}
        >
          {plStructure.current.map((val, key) => {
            return (
              <div
                key={key}
                className={cx({
                  [classes.plLineWrapper]: true,
                  [classes.plTotal]: val.level === 1,
                  [classes.plSubTotal]: val.level === 2,
                  [classes.plLevel3]: val.level === 3,
                  [classes.plLevel4]: val.level >= 4,
                  [classes.highlighted]:
                    (mouseOverPLLine &&
                      mouseOverPLLine === val.meta_name &&
                      timersAllowed) ||
                    pinnedName === val.meta_name ||
                    (fixedHighlightLine &&
                      fixedHighlightLine === val.meta_name),
                  [classes.faded]:
                    pinnedName !== undefined &&
                    pinnedName !== null &&
                    pinnedName !== val.meta_name,
                  [classes.hidden]: val.parent && isHiddenByAncestor(val),
                })}
                onMouseOut={
                  handleMouseLeavePLLine ? handleMouseLeavePLLine : null
                }
                onMouseOver={
                  handleMouseOverPLLine
                    ? () => handleMouseOverPLLine(val.meta_name)
                    : null
                }
              >
                {showNameColumn && (
                  <>
                    <div
                      className={cx({
                        [classes.plLineDescription]: true,
                        ["hidden"]: isHiddenView,
                        ["nameAndValue"]:
                          showColumns.length === 2 && !isThreeColumnView,
                        ["full"]: showColumns.length === 1,
                        ["threeCol"]: isThreeColumnView,
                        [classes.plDrillDown]: val.is_parent,
                        [classes.plDrillDownOpen]:
                          val.is_parent &&
                          drillDownsOpen.includes(val.meta_name),
                        [classes.plDrillDownClosed]:
                          val.is_parent &&
                          !drillDownsOpen.includes(val.meta_name),
                        [classes.plIndentL2]: val.level === 3 && !val.is_parent,
                        [classes.plIndentL3]: val.level >= 4 && !val.is_parent,
                        [classes.plDrillDownIndentL2]:
                          val.is_parent && val.parent && val.level === 3,
                        [classes.plDrillDownIndentL3]:
                          val.is_parent && val.parent && val.level >= 4,
                      })}
                    >
                      {val.is_parent && (
                        <span
                          onClick={() => handleDrillDownClick(val.meta_name)}
                        ></span>
                      )}
                      {val.parent && !val.is_parent && <span></span>}
                      {val.name}
                    </div>
                    {showPin && (
                      <span
                        className={cx({
                          [classes.pin]: true,
                          ["pinned"]: pinnedName === val.meta_name,
                        })}
                        onClick={() => handlePinClick(val.meta_name)}
                      />
                    )}
                  </>
                )}
                {showValueColumn && (
                  <div
                    className={cx({
                      [classes.plValue]: true,
                      [classes.plNumber]: true,
                      ["currency"]: true,
                      ["expanded"]: isExpandedView || isExpandedWithoutName,
                      ["nameAndValue"]: isCurrencyNameAndValue,
                      ["full"]: showColumns.length === 1,
                      ["negative"]:
                        val.level === 1 && isNegativeValue(val.meta_name),
                      ["threeCol"]: isThreeColumnView,
                    })}
                    onContextMenu={(event) =>
                      !isLoading &&
                      !isRefreshingOrToRefresh &&
                      handleContextMenu(event, val.meta_name, numPL, "value")
                    }
                    {...(showValueTooltip && {
                      onMouseEnter: (e) =>
                        handleValueCellMouseEnter(e, val.meta_name, numPL),
                      onMouseMove: handleValueCellMouseMove,
                      onMouseLeave: handleValueCellMouseLeave,
                    })}
                  >
                    {!isRefreshingOrToRefresh && (
                      <span>
                        {formatValue(
                          plValues[numPL]?.[val.meta_name],
                          val.meta_name,
                          numPL,
                          isThreeColumnView ? "value" : showValueType,
                          showValueByVolumeDecimals,
                        )}
                      </span>
                    )}
                    {isRefreshingOrToRefresh && plSpinner}
                  </div>
                )}
                {showValVolumeColumn && (
                  <div
                    className={cx({
                      [classes.plValue]: true,
                      [classes.plNumber]: true,
                      ["valVolume"]: true,
                      ["expanded"]: isExpandedView || isExpandedWithoutName,
                      ["negative"]:
                        val.level === 1 && isNegativeValue(val.meta_name),
                      ["threeCol"]: isThreeColumnView,
                    })}
                    onContextMenu={(event) =>
                      !isLoading &&
                      !isRefreshingOrToRefresh &&
                      handleContextMenu(event, val.meta_name, numPL, "value")
                    }
                    {...(showValueTooltip && {
                      onMouseEnter: (e) =>
                        handleValueCellMouseEnter(e, val.meta_name, numPL),
                      onMouseMove: handleValueCellMouseMove,
                      onMouseLeave: handleValueCellMouseLeave,
                    })}
                  >
                    {!isRefreshingOrToRefresh && (
                      <span>
                        {formatValue(
                          plValues[numPL]?.[val.meta_name],
                          val.meta_name,
                          numPL,
                          "per_unit",
                          showValueByVolumeDecimals,
                        )}
                      </span>
                    )}
                    {isRefreshingOrToRefresh && plSpinner}
                  </div>
                )}
                {showPercentageColumn && (
                  <div
                    className={cx({
                      [classes.plValue]: true,
                      [classes.plNumber]: true,
                      ["percentual"]: true,
                      ["expanded"]: isExpandedView || isExpandedWithoutName,
                      ["nameAndValue"]: isPercentualNameAndValue,
                      ["full"]: showColumns.length === 1,
                      ["negative"]:
                        val.level === 1 && isNegativeValue(val.meta_name),
                      [classes.plComparison]: shouldShowComparison(val),
                      ["n" + getCriticalityLevel(numPL, val.meta_name)]:
                        shouldShowComparison(val),
                      ["threeCol"]: isThreeColumnView,
                    })}
                    onContextMenu={(event) =>
                      !isLoading &&
                      !isRefreshingOrToRefresh &&
                      handleContextMenu(
                        event,
                        val.meta_name,
                        numPL,
                        "percentage",
                      )
                    }
                    {...(showValueTooltip && {
                      onMouseEnter: (e) =>
                        handleValueCellMouseEnter(e, val.meta_name, numPL),
                      onMouseMove: handleValueCellMouseMove,
                      onMouseLeave: handleValueCellMouseLeave,
                    })}
                  >
                    {!isRefreshingOrToRefresh &&
                      shouldShowDeltaArrow(val.meta_name) && (
                        <span
                          className={cx({
                            [classes.plDeltaArrow]: true,
                            ["n" +
                            getDeltaCriticalityLevel(
                              plLineDeltas[val.meta_name],
                              val.meta_name,
                            )]: true,
                          })}
                          style={{
                            transform: `rotate(${getDeltaRotation(plLineDeltas[val.meta_name], val.meta_name)}deg)`,
                            transformOrigin: "center center",
                          }}
                        >
                          <FontAwesomeIcon icon={faArrowUp} />
                        </span>
                      )}
                    {!isRefreshingOrToRefresh &&
                      (plValues[numPL]?.[val.meta_name] ? (
                        <span>{getPlPercentValue(numPL, val.meta_name)}</span>
                      ) : (
                        "-"
                      ))}
                    {isRefreshingOrToRefresh && plSpinner}
                  </div>
                )}
                {showDeltaColumn && (
                  <div
                    className={cx({
                      [classes.plValue]: true,
                      [classes.plNumber]: true,
                      ["percentual"]: true,
                      ["expanded"]: isExpandedView || isExpandedWithoutName,
                      ["nameAndValue"]: isPercentualNameAndValue,
                      ["full"]: showColumns.length === 1,
                      ["negative"]:
                        val.level === 1 &&
                        (() => {
                          const delta = calculateDeltaValue(val.meta_name);
                          return delta !== null && delta < 0;
                        })(),
                    })}
                  >
                    {!isRefreshingOrToRefresh &&
                      (() => {
                        const delta = calculateDeltaValue(val.meta_name);
                        if (delta === null) return "-";

                        const lineType = getLineType(val.meta_name);
                        const isRevenue = lineType === "revenue_anchor";

                        // Use exact same logic as plLineDeltas
                        const rotation = getDeltaRotation(delta, val.meta_name);
                        const criticalityLevel = getDeltaCriticalityLevel(
                          delta,
                          val.meta_name,
                        );

                        // Calculate opacity for fade effect (pass metaName for mouseOver check)
                        const opacity = calculateDeltaOpacity(
                          delta,
                          val.meta_name,
                        );

                        return (
                          <>
                            {!isRevenue && (
                              <span
                                className={cx({
                                  [classes.plDeltaArrow]: true,
                                  ["n" + criticalityLevel]: true,
                                })}
                                style={{
                                  transform: `rotate(${rotation}deg)`,
                                  transformOrigin: "center center",
                                }}
                              >
                                <FontAwesomeIcon icon={faArrowUp} />
                              </span>
                            )}
                            <span style={{ opacity }}>
                              {delta >= 0 ? "+" : ""}
                              {delta.toFixed(2)}
                              <span style={{ textTransform: "none" }}> pp</span>
                            </span>
                          </>
                        );
                      })()}
                    {isRefreshingOrToRefresh && plSpinner}
                  </div>
                )}
              </div>
            );
          })}
        </div>
        {/* endregion */}
      </div>
      {/* endregion */}

      {/* Context Menu */}
      <Menu
        open={contextMenu.mouseY !== null}
        onClose={handleCloseContextMenu}
        anchorReference="anchorPosition"
        anchorPosition={
          contextMenu.mouseY !== null && contextMenu.mouseX !== null
            ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
            : undefined
        }
        className={classes.contextMenu}
      >
        {shouldShowAnalysisOption && (
          <MenuItem
            onClick={handleOpenAnalysis}
            className={classes.contextMenuItem}
          >
            {t("pnl.open_analysis")}
          </MenuItem>
        )}
        <MenuItem
          onClick={handleMarkAsOpportunity}
          className={classes.contextMenuItem}
        >
          {t("pnl.mark_as_opportunity")}
        </MenuItem>
      </Menu>

      {/* Opportunity Dialog */}
      <Dialog
        open={opportunityDialogOpen}
        onClose={handleCloseOpportunityDialog}
        classes={{
          root: classes.modalRoot,
          paper: classes.modal,
        }}
        maxWidth="sm"
        fullWidth
      >
        <ModalHeader
          title={t("pnl.mark_as_opportunity")}
          subtitleParts={
            selectedOpportunity
              ? [selectedOpportunity.lineName]
              : null
          }
          onClose={handleCloseOpportunityDialog}
          closeDisabled={opportunitySubmitting}
          closeLabel={t("common.close")}
          clientColor={clientColor}
        />
        <DialogContent className={classes.modalBody}>
          {selectedOpportunity && (
            <div>
              <p>
                <strong>{t("pnl.pl_line")}:</strong>{" "}
                {selectedOpportunity.lineName}
              </p>
              <p>
                <strong>{t("pnl.value")}:</strong>{" "}
                {currencyUnit +
                  " " +
                  formatNumber(selectedOpportunity.value / oomData.div) +
                  oomData.x +
                  " (" +
                  getPlPercentValue(
                    selectedOpportunity.numPL,
                    selectedOpportunity.metaName,
                  ) +
                  " of sales)"}
              </p>
              <div>
                <strong>{t("pnl.scope")}:</strong>
                <div className={classes.opportunityDialogContainer}>
                  {(() => {
                    const scopeInfo = getScopeInformation();
                    if (!scopeInfo) {
                      return (
                        <p className={classes.scopePlaceholder}>
                          {t("pnl.scope_placeholder")}
                        </p>
                      );
                    }

                    return (
                      <div>
                        {scopeInfo.allFilters.length > 0 ? (
                          <div className={classes.filterContainer}>
                            {scopeInfo.allFilters.map((filter, index) => (
                              <FilterTag
                                key={index}
                                filtersList={["opportunity"]} // Dummy list for color cycling
                                filtersNames={{
                                  [filter.filterName]: {
                                    [i18n.language]: filter.name,
                                  },
                                }}
                                filter={filter.filterName}
                                items={filter.items}
                                indexes={filter.items.map((_, i) => i)}
                                mode="items"
                                color="gray"
                                viewOnly={true}
                              />
                            ))}
                          </div>
                        ) : (
                          <p className={classes.noFiltersMessage}>
                            {t("pnl.no_filters_applied")}
                          </p>
                        )}
                      </div>
                    );
                  })()}
                </div>
              </div>
              <div className={classes.opportunityInputContainer}>
                <CustomInput
                  labelText={t("pnl.opportunity_description_label")}
                  id="opportunity_description"
                  value={opportunityDescription}
                  onChange={(e) => setOpportunityDescription(e.target.value)}
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    type: "text",
                    autoComplete: "off",
                    maxLength: "60",
                    disabled: opportunitySubmitting,
                    style: { fontSize: "14px" },
                  }}
                  client
                  helperText={
                    opportunityDescription.length +
                    "/60 " +
                    t("results.characters")
                  }
                  ref={opportunityInputRef}
                  onEnterKey={() => handleConfirmOpportunity()}
                />
                <p className={classes.opportunityNote}>
                  {t("pnl.opportunity_initiatives_note")}
                </p>
              </div>
            </div>
          )}
        </DialogContent>
        <DialogActions className={classes.modalFooter}>
          <Button
            onClick={handleConfirmOpportunity}
            color="client"
            simple
            disabled={opportunitySubmitting || !opportunityDescription.trim()}
            style={{ minWidth: "120px" }}
          >
            {opportunitySubmitting ? (
              <ThreeDots
                color={clientColor}
                ariaLabel="loading"
                width={"20px"}
                height={"12px"}
              />
            ) : (
              t("initiatives.add_update_modal.confirm")
            )}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Value Tooltip (TreeMap style) */}
      {showValueTooltip && (
        <PnlTooltip
          visible={valueTooltip.visible}
          mouseMoving={mouseMoving}
          x={valueTooltip.x}
          y={valueTooltip.y}
          metaName={valueTooltip.metaName}
          numPL={valueTooltip.numPL}
          plValues={plValues}
          currencyUnit={currencyUnit}
          volumeUnit={volumeUnit.current}
          formatValue={formatValue}
          getPlPercentValue={getPlPercentValue}
          showValueByVolumeDecimals={showValueByVolumeDecimals}
          tooltipRef={tooltipRef}
          oomData={oomData}
          t={t}
        />
      )}
    </div>
  );
};

Pnl.defaultProps = {
  revenueAnchors: [],
  numPL: 1,
  numPLs: 1,
  maxPLs: 1,
  plsOnError: [],
  plsToRefresh: [],
  showValueType: "value",
  showColumns: ["name", "val", "percentage"],
  benchmark: "total_company",
  showPin: false,
  plLineDeltas: null,
  fixedHighlightLine: null,
  showValueTooltip: false,
  hideVolume: false,
};

Pnl.propTypes = {
  plStructure: PropTypes.object.isRequired,
  netRevenueAnchor: PropTypes.object.isRequired,
  combinedAboveAnchor: PropTypes.object,
  revenueReference: PropTypes.string,
  serveMarginAnchor: PropTypes.object.isRequired,
  revenueAnchors: PropTypes.array,
  marginAnchors: PropTypes.array,
  numPL: PropTypes.number,
  numPLs: PropTypes.number,
  maxPLs: PropTypes.number,
  plNames: PropTypes.object,
  plName: PropTypes.string,
  filterable: PropTypes.bool,
  handleChangePLNameClick: PropTypes.func,
  handleMouseLeavePLLine: PropTypes.func,
  handleMouseOverPLLine: PropTypes.func,
  mouseOverPLLine: PropTypes.string,
  mouseOverPLLineFade: PropTypes.string,
  handleOpenAnalysisDrawer: PropTypes.func,
  showAnalysisOption: PropTypes.bool,
  drillDownsOpen: PropTypes.array.isRequired,
  setDrillDownsOpen: PropTypes.func.isRequired,
  timersAllowed: PropTypes.bool,
  filtersListTranslated: PropTypes.func,
  filtersActiveList: PropTypes.func,
  filtersSequence: PropTypes.func,
  filterScopeData: PropTypes.object, // Optional - only needed for views with complex filter structures
  filterMenuClickHandler: PropTypes.func,
  filterDropdownProps: PropTypes.shape({
    filtersList: PropTypes.array.isRequired,
    filtersNames: PropTypes.object.isRequired,
    plFilters: PropTypes.object.isRequired,
    plFiltersSequence: PropTypes.array.isRequired,
    sections: PropTypes.array,
    language: PropTypes.string.isRequired,
    color: PropTypes.string,
  }),
  addPL: PropTypes.func,
  removePL: PropTypes.func,
  plsOnError: PropTypes.array,
  retryPL: PropTypes.func,
  plsToRefresh: PropTypes.array,
  isRefreshing: PropTypes.bool,
  plValues: PropTypes.object.isRequired,
  volumeUnit: PropTypes.object.isRequired,
  volumeL12M: PropTypes.object.isRequired,
  currencyUnit: PropTypes.string.isRequired,
  showValueType: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
  nameOnly: PropTypes.bool,
  showColumns: PropTypes.array,
  nameAlignRight: PropTypes.bool,
  benchmark: PropTypes.string,
  showPin: PropTypes.bool,
  pinnedName: PropTypes.string,
  setPinnedName: PropTypes.func,
  oom: PropTypes.object,
  onContextMenuStateChange: PropTypes.func,
  plLineDeltas: PropTypes.object,
  fixedHighlightLine: PropTypes.string,
  onOpenAIChat: PropTypes.func,
  showValueTooltip: PropTypes.bool,
  hideVolume: PropTypes.bool,
};

export default Pnl;
